import { createApiRef } from '@backstage/core-plugin-api';
import type {
  TechDebtIssue,
} from '@internal/backstage-plugin-techdebt-common';

export type TechDebtApi = {
  listIssuesByEntityRef(entityRef: string): Promise<TechDebtIssue[]>;
  createIssue(input: TechDebtIssue): Promise<TechDebtIssue>;
};

export const techDebtApiRef = createApiRef<TechDebtApi>({
  id: 'plugin.techdebt.service',
});
